

export class TyreModelAddInput implements ITyreModelAddInput {
    /** The auto-generated id of the tyre brand master */
    tyreBrandId!: number;
    /** The tyre model name with 255 character limit */
    tyreModelName!: string;

    constructor(data?: ITyreModelAddInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tyreBrandId = _data["tyreBrandId"];
            this.tyreModelName = _data["tyreModelName"];
        }
    }

    static fromJS(data: any): TyreModelAddInput {
        data = typeof data === 'object' ? data : {};
        let result = new TyreModelAddInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tyreBrandId"] = this.tyreBrandId;
        data["tyreModelName"] = this.tyreModelName;
        return data; 
    }
}

export interface ITyreModelAddInput {
    /** The auto-generated id of the tyre brand master */
    tyreBrandId: number;
    /** The tyre model name with 255 character limit */
    tyreModelName: string;
}

